import "core-js/modules/es6.set";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.some";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
import _classCallCheck from "/codebuild/output/src3842995830/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3842995830/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";

var ProcessedNodeManager = /*#__PURE__*/function () {
  function ProcessedNodeManager() {
    _classCallCheck(this, ProcessedNodeManager);

    this.nodeMap = new WeakMap();
    this.loop = true;
    this.periodicallyClear();
  }

  _createClass(ProcessedNodeManager, [{
    key: "periodicallyClear",
    value: function periodicallyClear() {
      var _this = this;

      requestAnimationFrame(function () {
        _this.clear();

        if (_this.loop) _this.periodicallyClear();
      });
    }
  }, {
    key: "inOtherBuffer",
    value: function inOtherBuffer(node, thisBuffer) {
      var buffers = this.nodeMap.get(node);
      return buffers && Array.from(buffers).some(function (buffer) {
        return buffer !== thisBuffer;
      });
    }
  }, {
    key: "add",
    value: function add(node, buffer) {
      this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.nodeMap = new WeakMap();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.loop = false;
    }
  }]);

  return ProcessedNodeManager;
}();

export { ProcessedNodeManager as default };